(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionDetailController', HandbookVersionDetailController);

    HandbookVersionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookVersion', 'Handbook', 'CustomUser', 'HandbookNode'];

    function HandbookVersionDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookVersion, Handbook, CustomUser, HandbookNode) {
        var vm = this;

        vm.handbookVersion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookVersionUpdate', function(event, result) {
            vm.handbookVersion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
